import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, expandCollapseKeyframes, expandCollapseInvertedKeyframes } from '@mgmresorts/wcl-styled';
import { isIE } from '@mgmresorts/wcl-utils';
import { rgba } from '../../../../node_modules/polished/dist/polished.esm.es.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var TRANSITION_DURATION = 300;
/**
 * The main wrapper that is offsetted by Tether
 */

var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Wrapper which will be expanded/collapsed by animation
 */

var StyledAnimationWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  background-color: ", ";\n  overflow: hidden;\n  will-change: transform;\n  backface-visiblity: hidden;\n  transform-origin: top;\n  ", "\n  // When it goes to the bottom\n  ", ".tether-target-attached-bottom &,\n  ", ".tether-pinned-top & {\n    box-shadow: 0px 5px 5px ", ";\n  }\n  // When it goes to the top\n  ", ".tether-target-attached-top &,\n  ", ".tether-pinned-bottom & {\n    transform-origin: bottom;\n    box-shadow: 0px -5px 5px ", ";\n  }\n"])), expandCollapseKeyframes, function (p) {
  return p.theme.colors.white;
}, function (p) {
  return p.animation && "\n    // Note: We need to use step-end instead of linear here,\n    // because linear doesn't work well on Safari\n    // ( https://mgmdigitalventures.atlassian.net/browse/WEB-10076 )\n    animation: ".concat(p.animation, " ").concat(TRANSITION_DURATION, "ms step-end forwards;\n  ");
}, StyledWrapper, StyledWrapper, function (p) {
  return rgba(p.theme.colors.black, 0.1);
}, StyledWrapper, StyledWrapper, function (p) {
  return rgba(p.theme.colors.black, 0.1);
});
/**
 * Wrapper contents which will receive the inverted expand/collapse animation
 */

var StyledInvertedAnimationWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  will-change: transform;\n  backface-visiblity: hidden;\n  transform-origin: top;\n  ", "\n  // When it goes to the top\n  ", ".tether-target-attached-top &,\n  ", ".tether-pinned-bottom & {\n    transform-origin: bottom;\n  }\n"])), // That animation causes white dropdown content on scroll on IE
isIE() ? '' : expandCollapseInvertedKeyframes, function (p) {
  return p.animation && "\n    animation: ".concat(p.animation // Note: We need to use step-end instead of linear here,
  // because linear doesn't work well on Safari
  // ( )
  , "Inverted ").concat(TRANSITION_DURATION, "ms step-end forwards;\n  ");
}, StyledWrapper, StyledWrapper);
/**
 * Scrolling wrapper (that receives `max-height` and thus might have a vertical scrollbar)
 */

var StyledScrollWrapper = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  overflow-y: visible;\n"])));
var StyledA11yCloseButton = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  position: absolute !important;\n  width: 1px;\n  word-wrap: normal !important;\n  bottom: 0;\n"])));

export { StyledA11yCloseButton, StyledAnimationWrapper, StyledInvertedAnimationWrapper, StyledScrollWrapper, StyledWrapper, TRANSITION_DURATION };
